const freezeContainer = {
  height: 'calc(100vh - 64px)',
  overflow: 'hidden',
}

export default freezeContainer